export default __webpack_public_path__ + "media/images/users/user-eva-pool-370x370-fedbe827c83f2470281e49300863c83f.jpg";